import { render } from "./DataQuality.vue?vue&type=template&id=aa8ba086"
import script from "./DataQuality.vue?vue&type=script&lang=js"
export * from "./DataQuality.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__